(function(root, factory) {
    root.BIC = factory();
})(window, function() {
    var validBicRegex = new RegExp("^[A-Z]{6}[2-9A-Z][0-9A-NP-Z](?:(?:[0-9A-WY-Z][0-9A-Z]{2})|X{3})?$", "i");

    return {
        isValid: function(bic) {
            return validBicRegex.test(bic);
        }
    };
});
